<hb-df-dropdown [control]="libraryControl" [formGroup]="formGroup"></hb-df-dropdown>

<hb-industry-hierarchy
  [model]="criteria"
  [formGroup]="formGroup"
  [showIndustryHierarchy]="true"
  [allowUserEntry]="false"
  [isEditable]="isEditable"
  (selectionsChanged)="onIndustryHierarchySelectionsChanged()">
</hb-industry-hierarchy>

<hb-equipment-class
  [model]="criteria"
  [formGroup]="formGroup"
  [isEditable]="isEditable"
  (selectionsChanged)="onEquipmentClassSelectionsChanged()">
</hb-equipment-class>
